import { Component, OnInit } from "@angular/core";
import { AuthService } from "src/app/auth.service";
import { DataServiceService } from "src/app/data-service.service";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit {
  public uiBasicCollapsed = false;
  public samplePagesCollapsed = false;
  userName: string = "";
  userImageUrl: string = "";
  isUserAdmin: boolean = false;
  companyName: string = "";
  isLoading: boolean = true;
  isUserSuperAdmin: boolean = false;

  constructor(
    private authService: AuthService,
    private dataService: DataServiceService
  ) {}

  ngOnInit() {
    this.userName = this.authService.getCurrentUser().userName;
    this.userImageUrl = `https://ui-avatars.com/api/?name=${this.userName}&background=fff&color=B002B4&bold=true&length=1`;
    this.isUserAdmin = this.authService.isUserAdmin();
    this.isUserSuperAdmin = this.authService.isUserSuperAdmin();
    if (!this.isUserAdmin) {
      this.getCompanyName().then(() => {
        this.isLoading = false;
      });
    }
    const body = document.querySelector("body");

    // add class 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
    document.querySelectorAll(".sidebar .nav-item").forEach(function (el) {
      el.addEventListener("mouseover", function () {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.add("hover-open");
        }
      });
      el.addEventListener("mouseout", function () {
        if (body.classList.contains("sidebar-icon-only")) {
          el.classList.remove("hover-open");
        }
      });
    });
  }

  async getCompanyName() {
    this.companyName = await this.dataService.getCompanyNameById(
      this.authService.getCurrentUser().companyId
    );
  }
}
